const screens = {
  xs: "425px",
  xm: "576px",
  sm: "768px",
  md: "992px",
  lg: "1200px",
  xl: "1366px",
  xxl: "1600px",
  xxxl: "1920px",
};

export default {
  screens,
};
